export const HOMEOWNER_PORTAL_ROUTES = {
  LANDING: `/homeowner-portal`,
  ABOUT_MY_HOME: `/homeowner-portal/learn-more-about-my-home`,
  LEARN_MORE_COMMUNITY: `/homeowner-portal/learn-more-about-my-community`,
  WARRANTY_PORTAL: `/homeowner-portal/warranty-portal`,
  CONSTRUCTION_PHASES: `/homeowner-portal/construction-phases`,
  REFERRAL: `/homeowner-portal/referral-program`,
  SUBMIT_PHOTOS: `/homeowner-portal/submit-photos`
};
